var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "message-area-header" } },
    [
      _vm.superMenu.enabled
        ? _c("SuperMenu", {
            attrs: { contact: _vm.contact },
            on: {
              updateSuperMenuState: function ($event) {
                _vm.superMenu = $event
              },
              usedComamnd: _vm.usedSlashCommand,
              send: function ($event) {
                return _vm.$emit("send", $event)
              },
            },
            model: {
              value: _vm.superMenu,
              callback: function ($$v) {
                _vm.superMenu = $$v
              },
              expression: "superMenu",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "conversation-types" }, [
        _c(
          "div",
          {
            staticClass: "conversation-types-item",
            class: { selected: _vm.mode === "chat" },
            on: {
              click: function ($event) {
                return _vm.selectMode("chat")
              },
            },
          },
          [
            _c("div", { staticClass: "material-icons" }, [_vm._v("language")]),
            _vm._v(
              "\n            " + _vm._s(_vm.$t("auto.chat")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "conversation-types-item",
            class: { selected: _vm.mode === "email" },
            on: {
              click: function ($event) {
                return _vm.$feature.beforeClickEmailFn(_vm.selectMailMode)
              },
            },
          },
          [
            _c("div", { staticClass: "material-icons" }, [_vm._v("mail")]),
            _vm._v(
              "\n            " + _vm._s(_vm.$t("auto.email")) + "\n        "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }